var React = require('react');

function File (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2.5"},[React.createElement("path",{"d":"M9.2 2H3.6A1.6 1.6 0 0 0 2 3.6v12.8A1.6 1.6 0 0 0 3.6 18h9.6a1.6 1.6 0 0 0 1.6-1.6V7.6L9.2 2z","key":0}),React.createElement("path",{"d":"M9.2 2v5.6h5.6","key":1})]));
}

File.defaultProps = {"width":"17","height":"20","viewBox":"0 0 17 20"};

module.exports = File;

File.default = File;
